class ContactFabMenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.contact-fab__toggle');
    this.toggle.addEventListener('click', this.handleToggleClick);
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeydown);

    // Some mobile browsers leave fixed-position elements clipped on the
    // initial paint when the page has an autoplaying scroll-timeline
    // animation (the homepage's hero carousel). A tiny, imperceptible
    // scroll nudge forces the same repaint that manually scrolling does.
    requestAnimationFrame(() => {
      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
    });
  }

  disconnectedCallback() {
    this.toggle.removeEventListener('click', this.handleToggleClick);
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleToggleClick = (event) => {
    event.stopPropagation();
    this.setOpen(!this.hasAttribute('open'));
  };

  handleOutsideClick = (event) => {
    if (this.hasAttribute('open') && !this.contains(event.target)) {
      this.setOpen(false);
    }
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.hasAttribute('open')) {
      this.setOpen(false);
      this.toggle.focus();
    }
  };

  setOpen(open) {
    this.toggleAttribute('open', open);
    this.toggle.setAttribute('aria-expanded', String(open));

    this.querySelectorAll('.contact-fab__item').forEach((item) => {
      item.setAttribute('tabindex', open ? '0' : '-1');
    });
  }
}

if (!customElements.get('contact-fab-menu')) {
  customElements.define('contact-fab-menu', ContactFabMenu);
}
